import React from 'react';
import { useLocation } from 'react-router-dom';
import { usePublicTenant } from '../hooks/usePublicTenant';

const PUBLIC_OFF_PATHS = ['/admin', '/accounts', '/leverantor', '/dj-portal'];

/** Länkar som ska fungera även när tenant saknar channel (t.ex. e-postlänk till offert, self-service registrering). */
const PUBLIC_ALWAYS_PATHS = ['/offert', '/registrera', '/mina-bokningar', '/betala-igen'];

function isPublicRoute(pathname: string): boolean {
  return PUBLIC_OFF_PATHS.every((p) => !pathname.startsWith(p));
}

function isAlwaysPublicPath(pathname: string): boolean {
  return PUBLIC_ALWAYS_PATHS.some((p) => pathname.startsWith(p));
}

/**
 * Fas 2 Sprint 3: Om användaren besöker en publik route och tenant saknar channel-modulen,
 * visa "Website är inte aktiverad" istället för innehållet. Admin/accounts/leverantor påverkas inte.
 */
export default function PublicSiteGate({ children }: { children: React.ReactNode }) {
  const location = useLocation();
  const { channelEnabled, loading } = usePublicTenant();

  if (!isPublicRoute(location.pathname)) {
    return <>{children}</>;
  }

  /* Offertlänk från e-post ska alltid laddas – kräv inte channel. */
  if (isAlwaysPublicPath(location.pathname)) {
    return <>{children}</>;
  }

  if (loading) {
    return (
      <div className="min-h-[40vh] flex items-center justify-center bg-gray-50">
        <div className="animate-spin rounded-full h-10 w-10 border-t-2 border-b-2 border-indigo-600" />
      </div>
    );
  }

  if (!channelEnabled) {
    return (
      <div className="min-h-[60vh] flex items-center justify-center bg-gray-50 px-4">
        <div className="text-center max-w-md">
          <h1 className="text-xl font-semibold text-gray-800 mb-2">Webbplatsen är inte aktiverad</h1>
          <p className="text-gray-600">
            Denna webbplats är för närvarande inte aktiverad för det här kontot. Kontakta din leverantör om du har
            frågor.
          </p>
        </div>
      </div>
    );
  }

  return <>{children}</>;
}
